import { render } from "./SelectItemType.vue?vue&type=template&id=105402e2"
import script from "./SelectItemType.vue?vue&type=script&lang=js"
export * from "./SelectItemType.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__